import React, { useEffect, useState } from "react";
import AddStudySupplementary from "./AddStudySupplementary";
import SplitPane from "react-split-pane";
import StudySupplementaryTableData from "./StudySupplementaryTableData";
import StudySupplementaryTableProperties from "./StudySupplementaryTableProperties";
import UseToggle from "../../../../../Hooks/UseToggle";
import { cdiscServices } from "../../../../../Services/CDISC/cdiscServices";
import { useParams } from "react-router";
import { studyOnboardingService } from "../../../../../Services/studyServices/studyOnboarding";
import { NoDataFoundTable, SpinerDataLoader } from "../../../../NoDataFoundTable/NoDataFoundTable";

const StudySupplementary = ({ onMouseDown, tableRef }) => {
  const [loader, setLoader] = useState(false);
  const { toggle, setToggle } = UseToggle();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [addNewStudySupplementarydata, setaddNewStudySupplementarydata] =
    useState([]);
  const [studySupplementaryData, setstudySupplementaryData] = useState("");
  const [versionId, setVersionId] = useState("");
  const { studyId } = useParams();

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const getSupplimentalsList = async () => {
    setLoader(true);
    let data = await cdiscServices.getStudySupplimentalsList(studyId);
    setaddNewStudySupplementarydata(data?.data);
    setLoader(false);
  };

  const getSingleStudies = async () => {
    let data = await studyOnboardingService.getSingleStudies(studyId);
    setVersionId(data?.data?.[0]?.version || "");
  };

  useEffect(() => {
    getSupplimentalsList();
  }, []);

  useEffect(() => {
    getSingleStudies(studyId);
  }, [studyId]);

  return (
    <div className={`code-list-container ${isFullScreen ? "full-screen" : ""}`}>
      <div className="p-1 hstack justify-content-between border-bottom toolbar">
        <div className="hstack gap-2">
          {isFormOpen ? (
            <i
              title="Close Form"
              className="fa-solid fa-square-caret-left CP"
              onClick={() => setIsFormOpen("")}
            />
          ) : (
            <i
              title="Add CRF Data"
              className="fa-solid fa-plus CP"
              onClick={() => setIsFormOpen(!isFormOpen)}
            />
          )}
          <div className="vr"></div>
          <i
            title="Table Properties"
            className="fa-solid fa-list CP"
            onClick={setToggle}
          />
        </div>
        {isFullScreen ? (
          <i
            className="fa-solid fa-maximize"
            title="Original Mode"
            onClick={toggleFullScreen}
          ></i>
        ) : (
          <i
            className="fa-solid fa-minimize"
            title="Full Mode"
            onClick={toggleFullScreen}
          ></i>
        )}
      </div>
      <div className="position-relative">
        <SplitPane
          split="horizontal"
          style={{
            height: isFullScreen ? "calc(100vh - 35px)" : "calc(100vh - 185px)",
          }}
          defaultSize={"100%"}
        >
          <SplitPane
            split="vertical"
            minSize={20}
            defaultSize={isFormOpen ? "20%" : "100%"}
          >
            {isFormOpen && (
              <AddStudySupplementary
                studyId={studyId}
                versionId={versionId}
                studySupplementaryData={studySupplementaryData}
                setstudySupplementaryData={setstudySupplementaryData}
                getSupplimentalsList={getSupplimentalsList}
              />
            )}
            <>
              {loader ? (
                <SpinerDataLoader />
              ) : addNewStudySupplementarydata?.length === 0 ? (
                <NoDataFoundTable MSG={" Data Not Found!"} />
              ) : (
                <StudySupplementaryTableData
                  studyId={studyId}
                  onMouseDown={onMouseDown}
                  tableRef={tableRef}
                  setIsFormOpen={setIsFormOpen}
                  addNewStudySupplementarydata={addNewStudySupplementarydata}
                  setSupplimentaryData={setstudySupplementaryData}
                  getSupplimentalsList={getSupplimentalsList}
                />
              )}
            </>
          </SplitPane>
        </SplitPane>
      </div>
      <StudySupplementaryTableProperties
        Show={!toggle}
        Hide={setToggle}
        Title={"Table Properties"}
      />
      {/* <StudySupplementaryFilterData
        Show={!toggle1}
        Hide={setToggle1}
        Title={"Filter StudySupplementary"}
        studyId={studyId}
        filter={filter}
        setFilter={setFilter}
        getSupplimentalsList={getSupplimentalsList}
        setaddNewStudySupplementarydata={setaddNewStudySupplementarydata}
        addNewStudySupplementarydata={addNewStudySupplementarydata}
      /> */}
    </div>
  );
};

export default StudySupplementary;
